import type { FaireProductEntity } from "../../entity_types/product";

export const p_ckprxtk8fc: FaireProductEntity = {
  token: "p_ckprxtk8fc",
  type: "product",
  name: "True Ocean Foaming Mineral Bath - 5oz.",
  brandToken: "b_gnezccqqak",
  brandName: "True Ocean",
  imageUrl:
    "https://cdn.faire.com/fastly/45e6550470bc216fbd34e4dd23e4afbb444ab4ae5dd12342adc34fd225ef9cb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/707df440821e5de184ad95110225a6e2008484e3bfde84f0562aa08d6032c0fa.jpeg",
    "https://cdn.faire.com/fastly/d841491e505a2d21f4e534594f5005d4a7875a5a45b3db9e6fcf5f675f2a7aaf.png",
    "https://cdn.faire.com/fastly/639d42e4b835f6dd388c4251b49a23d8accc0f825792ea7e2257531afcb2697d.png",
  ],
  priceDollars: 9,
  description:
    "Our Foaming Mineral Bath infuses water with mineral-rich sea salts and skin-conditioning bubbles that gently foam around you. Melt away tension and enjoy our signature Coastal scent as you relax. Leaves skin feeling soft, smooth, and replenished. It’s a coastal escape, right in your tub.\n\n- 5 oz / 141 g\n- Made in the USA\n- TSA approved\n- NO parabens, sulfates, or phthalates\n\nExperience True Ocean's line of ocean water body care today! Enjoy the beach anywhere you go. Perfect beach gift, Christmas gift, holiday gift, souvenir, coastal decor, mother's day gift, father's day gift, birthday gift, unisex fragrances, luxury bath, for spas, resorts boutiques and more!\n\nAs always, free shipping with Faire Insider.\n\nA perfect gift to treat yourself while the kids go back to school this fall! Be sure to check out our Coastal Candle, it’s the perfect fall decor gift. The beach is going to be amazing this fall and Halloween. Our products are also the perfect Christmas stocking stuffers. Customers can experience Christmas at the beach. The holidays never felt so coastal. Merry Christmas!",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:03.854Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
